export default __webpack_public_path__ + "static/media/6.87685bc7.jpg";